module.exports = __webpack_public_path__ + "img/nova_osoba.41bd52dc.svg";